export interface ScoreWeight {
  tipo: string;
  label: string;
  peso: number;
}

export const SCORE_WEIGHTS: readonly ScoreWeight[] = [
  { tipo: "avaliacao_projeto_boa", label: "Avaliação projeto boa (≥8)", peso: 0.8 },
  { tipo: "aprovado", label: "Aprovado", peso: 0.7 },
  { tipo: "projeto_concluido", label: "Projeto concluído", peso: 0.6 },
  { tipo: "shortlist", label: "Shortlist", peso: 0.5 },
  { tipo: "avaliacao_perfil_alta", label: "Avaliação perfil alta (≥7)", peso: 0.5 },
  { tipo: "ia_confirmado", label: "IA confirmado", peso: 0.4 },
  { tipo: "selecionado", label: "Selecionado", peso: 0.3 },
  { tipo: "ia_recomendou", label: "IA recomendou", peso: 0.1 },
  { tipo: "drop", label: "Drop", peso: -0.2 },
  { tipo: "avaliacao_projeto_ruim", label: "Avaliação projeto ruim (≤4)", peso: -0.5 },
] as const;

export const SCORE_FORMULA_DESC =
  "Score = sigmoid(Σ peso × e^(−0.1 × meses)), normalizado de 0 a 100.";
